import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeModel, IT_MANAGEMENT_COMPONENT, SalesModuleApiSuffixModels } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee.component.scss'],
})
export class EmployeeListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: "Employees",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management', relativeRouterUrl: '' }, { displayName: 'Employee List', relativeRouterUrl: '' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Employee',
          dataKey: 'employeeId',
          enableAction: true,
          columns: [{ field: 'userRefNo', header: 'User ID', width: '120px' },
          { field: 'employeeNo', header: 'Employee No/PSIRA Registration No', width: '220px' },
          { field: 'vendorNo', header: 'Vendor No', width: '120px' },
          { field: 'name', header: 'Name', width: '200px' },
          { field: 'roleName', header: 'Role', width: '150px' },
          { field: 'branchName', header: 'Branch', width: '200px', isparagraph: true },
          { field: 'emailAddress', header: 'Email', width: '200px', isparagraph: true },
          { field: 'extensionNo', header: 'Extension No.', width: '170px', isparagraph: true },
          { field: 'contactNumber', header: 'Contact No', width: '120px', isPhoneMask: true },
          { field: 'isActive', header: 'Status', width: '130px' }
          ],
          apiSuffixModel: SalesModuleApiSuffixModels.SALES_API_EMPLOYEE_LISTING,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService, private snackbarService: SnackbarService,
    private store: Store<AppState>,
    public dialogService: DialogService,
    private router: Router,) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.getOpsList()
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.EMPLOYEE]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getOpsList(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      SalesModuleApiSuffixModels.SALES_API_EMPLOYEE_LISTING,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams), 1
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  getTicketTypes(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.ACTION_TYPE,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams), 1
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });;
  }

  onCRUDRequested(type: CrudType | string, row?: any, searchObj?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.getOpsList(row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.VIEW:
          this.openAddEditPage(CrudType.VIEW, row);
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  openAddEditPage(type: CrudType | string, editableObject?: EmployeeModel | any): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.router.navigateByUrl("/user/employee/add-edit");
        }
        break;
      case CrudType.VIEW:
        this.router.navigate(["/user/employee/view"], { queryParams: { id: editableObject['employeeId'] } });
        break;
    }
  }
}

